// Location data for cascading dropdowns
export const locationData = {
  'USA': {
    'Alabama': ['Birmingham', 'Montgomery', 'Mobile', 'Huntsville', 'Tuscaloosa'],
    'Alaska': ['Anchorage', 'Fairbanks', 'Juneau', 'Wasilla', 'Sitka'],
    'Arizona': ['Phoenix', 'Tucson', 'Mesa', 'Chandler', 'Scottsdale'],
    'Arkansas': ['Little Rock', 'Fort Smith', 'Fayetteville', 'Springdale', 'Jonesboro'],
    'California': ['Los Angeles', 'San Francisco', 'San Diego', 'Sacramento', 'Fresno', 'San Jose', 'Oakland', 'Long Beach', 'Anaheim', 'Santa Ana'],
    'Colorado': ['Denver', 'Colorado Springs', 'Aurora', 'Fort Collins', 'Lakewood'],
    'Connecticut': ['Bridgeport', 'New Haven', 'Hartford', 'Stamford', 'Waterbury'],
    'Delaware': ['Wilmington', 'Dover', 'Newark', 'Middletown', 'Smyrna'],
    'Florida': ['Miami', 'Orlando', 'Tampa', 'Jacksonville', 'Fort Lauderdale', 'Tallahassee', 'St. Petersburg', 'Hialeah', 'Port St. Lucie', 'Cape Coral'],
    'Georgia': ['Atlanta', 'Augusta', 'Columbus', 'Macon', 'Savannah', 'Athens', 'Sandy Springs', 'Roswell', 'Johns Creek'],
    'Hawaii': ['Honolulu', 'Pearl City', 'Hilo', 'Kailua', 'Kaneohe'],
    'Idaho': ['Boise', 'Nampa', 'Meridian', 'Idaho Falls', 'Pocatello'],
    'Illinois': ['Chicago', 'Springfield', 'Peoria', 'Rockford', 'Naperville', 'Aurora', 'Joliet', 'Elgin', 'Waukegan'],
    'Indiana': ['Indianapolis', 'Fort Wayne', 'Evansville', 'South Bend', 'Carmel'],
    'Iowa': ['Des Moines', 'Cedar Rapids', 'Davenport', 'Sioux City', 'Iowa City'],
    'Kansas': ['Wichita', 'Overland Park', 'Kansas City', 'Topeka', 'Olathe'],
    'Kentucky': ['Louisville', 'Lexington', 'Bowling Green', 'Owensboro', 'Covington'],
    'Louisiana': ['New Orleans', 'Baton Rouge', 'Shreveport', 'Lafayette', 'Lake Charles'],
    'Maine': ['Portland', 'Lewiston', 'Bangor', 'South Portland', 'Auburn'],
    'Maryland': ['Baltimore', 'Frederick', 'Rockville', 'Gaithersburg', 'Bowie'],
    'Massachusetts': ['Boston', 'Worcester', 'Springfield', 'Lowell', 'Cambridge'],
    'Michigan': ['Detroit', 'Grand Rapids', 'Warren', 'Sterling Heights', 'Lansing', 'Ann Arbor', 'Flint', 'Dearborn'],
    'Minnesota': ['Minneapolis', 'St. Paul', 'Rochester', 'Duluth', 'Bloomington'],
    'Mississippi': ['Jackson', 'Gulfport', 'Southaven', 'Hattiesburg', 'Biloxi'],
    'Missouri': ['Kansas City', 'St. Louis', 'Springfield', 'Columbia', 'Independence'],
    'Montana': ['Billings', 'Missoula', 'Great Falls', 'Bozeman', 'Butte'],
    'Nebraska': ['Omaha', 'Lincoln', 'Bellevue', 'Grand Island', 'Kearney'],
    'Nevada': ['Las Vegas', 'Henderson', 'Reno', 'North Las Vegas', 'Sparks'],
    'New Hampshire': ['Manchester', 'Nashua', 'Concord', 'Derry', 'Rochester'],
    'New Jersey': ['Newark', 'Jersey City', 'Paterson', 'Elizabeth', 'Edison'],
    'New Mexico': ['Albuquerque', 'Las Cruces', 'Rio Rancho', 'Santa Fe', 'Roswell'],
    'New York': ['New York City', 'Buffalo', 'Rochester', 'Syracuse', 'Albany', 'Yonkers', 'Utica', 'New Rochelle'],
    'North Carolina': ['Charlotte', 'Raleigh', 'Greensboro', 'Durham', 'Winston-Salem', 'Fayetteville', 'Cary', 'Wilmington'],
    'North Dakota': ['Fargo', 'Bismarck', 'Grand Forks', 'Minot', 'West Fargo'],
    'Ohio': ['Columbus', 'Cleveland', 'Cincinnati', 'Toledo', 'Akron', 'Dayton', 'Parma'],
    'Oklahoma': ['Oklahoma City', 'Tulsa', 'Norman', 'Broken Arrow', 'Lawton'],
    'Oregon': ['Portland', 'Eugene', 'Salem', 'Gresham', 'Hillsboro'],
    'Pennsylvania': ['Philadelphia', 'Pittsburgh', 'Allentown', 'Erie', 'Reading', 'Scranton', 'Bethlehem', 'Lancaster'],
    'Rhode Island': ['Providence', 'Warwick', 'Cranston', 'Pawtucket', 'East Providence'],
    'South Carolina': ['Charleston', 'Columbia', 'North Charleston', 'Mount Pleasant', 'Rock Hill'],
    'South Dakota': ['Sioux Falls', 'Rapid City', 'Aberdeen', 'Brookings', 'Watertown'],
    'Tennessee': ['Nashville', 'Memphis', 'Knoxville', 'Chattanooga', 'Clarksville'],
    'Texas': ['Houston', 'Dallas', 'Austin', 'San Antonio', 'Fort Worth', 'El Paso', 'Arlington', 'Corpus Christi', 'Plano', 'Laredo'],
    'Utah': ['Salt Lake City', 'West Valley City', 'Provo', 'West Jordan', 'Orem'],
    'Vermont': ['Burlington', 'Essex', 'South Burlington', 'Colchester', 'Montpelier'],
    'Virginia': ['Virginia Beach', 'Norfolk', 'Chesapeake', 'Richmond', 'Newport News'],
    'Washington': ['Seattle', 'Spokane', 'Tacoma', 'Vancouver', 'Bellevue'],
    'West Virginia': ['Charleston', 'Huntington', 'Parkersburg', 'Morgantown', 'Wheeling'],
    'Wisconsin': ['Milwaukee', 'Madison', 'Green Bay', 'Kenosha', 'Racine'],
    'Wyoming': ['Cheyenne', 'Casper', 'Laramie', 'Gillette', 'Rock Springs']
  },
  'India': {
    'Andhra Pradesh': ['Visakhapatnam', 'Vijayawada', 'Guntur', 'Nellore', 'Kurnool'],
    'Arunachal Pradesh': ['Itanagar', 'Naharlagun', 'Pasighat', 'Bomdila', 'Tawang'],
    'Assam': ['Guwahati', 'Silchar', 'Dibrugarh', 'Jorhat', 'Nagaon'],
    'Bihar': ['Patna', 'Gaya', 'Bhagalpur', 'Muzaffarpur', 'Purnia'],
    'Chhattisgarh': ['Raipur', 'Bilaspur', 'Durg', 'Bhilai', 'Korba'],
    'Delhi': ['New Delhi', 'Delhi Cantonment', 'Dwarka', 'Rohini', 'Pitampura', 'Noida', 'Gurgaon', 'Ghaziabad'],
    'Goa': ['Panaji', 'Margao', 'Vasco da Gama', 'Mapusa', 'Ponda'],
    'Gujarat': ['Ahmedabad', 'Surat', 'Vadodara', 'Rajkot', 'Bhavnagar', 'Jamnagar', 'Gandhinagar', 'Anand'],
    'Haryana': ['Faridabad','Palwal','Gurgaon', 'Panipat', 'Ambala', 'Yamuna Nagar', 'Rohtak', 'Hisar', 'Karnal'],
    'Himachal Pradesh': ['Shimla', 'Manali', 'Dharamshala', 'Solan', 'Kullu'],
    'Jammu and Kashmir': ['Srinagar', 'Jammu', 'Anantnag', 'Baramulla', 'Udhampur'],
    'Jharkhand': ['Ranchi', 'Jamshedpur', 'Dhanbad', 'Bokaro', 'Hazaribagh'],
    'Karnataka': ['Bangalore', 'Mysore', 'Hubli', 'Mangalore', 'Belgaum', 'Gulbarga', 'Davangere', 'Shimoga'],
    'Kerala': ['Thiruvananthapuram', 'Kochi', 'Kozhikode', 'Thrissur', 'Kollam', 'Kannur', 'Alappuzha', 'Palakkad'],
    'Madhya Pradesh': ['Indore', 'Bhopal', 'Gwalior', 'Jabalpur', 'Ujjain', 'Raipur', 'Dewas', 'Sagar'],
    'Maharashtra': ['Mumbai', 'Pune', 'Nagpur', 'Thane', 'Nashik', 'Aurangabad', 'Solapur', 'Amravati', 'Kolhapur', 'Sangli'],
    'Manipur': ['Imphal', 'Thoubal', 'Bishnupur', 'Churachandpur', 'Kakching'],
    'Meghalaya': ['Shillong', 'Tura', 'Jowai', 'Nongstoin', 'Baghmara'],
    'Mizoram': ['Aizawl', 'Lunglei', 'Champhai', 'Serchhip', 'Kolasib'],
    'Nagaland': ['Kohima', 'Dimapur', 'Mokokchung', 'Tuensang', 'Wokha'],
    'Odisha': ['Bhubaneswar', 'Cuttack', 'Rourkela', 'Berhampur', 'Sambalpur'],
    'Punjab': ['Ludhiana', 'Amritsar', 'Jalandhar', 'Patiala', 'Bathinda', 'Mohali', 'Hoshiarpur'],
    'Rajasthan': ['Jaipur', 'Jodhpur', 'Kota', 'Bikaner', 'Ajmer', 'Udaipur', 'Bhilwara', 'Alwar'],
    'Sikkim': ['Gangtok', 'Namchi', 'Mangan', 'Gyalshing', 'Singtam'],
    'Tamil Nadu': ['Chennai', 'Coimbatore', 'Madurai', 'Salem', 'Vellore', 'Tiruchirappalli', 'Tirunelveli', 'Erode'],
    'Telangana': ['Hyderabad', 'Warangal', 'Nizamabad', 'Karimnagar', 'Khammam', 'Ramagundam', 'Mahabubnagar', 'Nalgonda'],
    'Tripura': ['Agartala', 'Udaipur', 'Dharmanagar', 'Kailasahar', 'Belonia'],
    'Uttar Pradesh': ['Lucknow', 'Kanpur', 'Varanasi', 'Agra', 'Prayagraj', 'Meerut', 'Ghaziabad', 'Noida', 'Bareilly', 'Aligarh'],
    'Uttarakhand': ['Dehradun', 'Haridwar', 'Rishikesh', 'Nainital', 'Mussoorie'],
    'West Bengal': ['Kolkata', 'Howrah', 'Durgapur', 'Asansol', 'Siliguri', 'Darjeeling', 'Kharagpur', 'Bardhaman']
  },
  'Canada': {
    'Alberta': ['Calgary', 'Edmonton', 'Red Deer', 'Lethbridge', 'Medicine Hat', 'Airdrie', 'St. Albert', 'Grande Prairie'],
    'British Columbia': ['Vancouver', 'Surrey', 'Burnaby', 'Richmond', 'Abbotsford', 'Victoria', 'Kelowna', 'Nanaimo'],
    'Manitoba': ['Winnipeg', 'Brandon', 'Steinbach', 'Thompson', 'Portage la Prairie', 'Winkler', 'Selkirk'],
    'New Brunswick': ['Saint John', 'Moncton', 'Fredericton', 'Dieppe', 'Miramichi', 'Riverview', 'Edmundston'],
    'Newfoundland and Labrador': ['St. John\'s', 'Mount Pearl', 'Corner Brook', 'Grand Falls-Windsor', 'Gander', 'Conception Bay South', 'Happy Valley-Goose Bay'],
    'Northwest Territories': ['Yellowknife', 'Hay River', 'Inuvik', 'Fort Smith', 'Behchoko'],
    'Nova Scotia': ['Halifax', 'Sydney', 'Dartmouth', 'Truro', 'New Glasgow', 'Glace Bay', 'Kentville'],
    'Nunavut': ['Iqaluit', 'Rankin Inlet', 'Arviat', 'Baker Lake', 'Cambridge Bay'],
    'Ontario': ['Toronto', 'Ottawa', 'Mississauga', 'Brampton', 'Hamilton', 'London', 'Markham', 'Windsor', 'Kitchener', 'Waterloo'],
    'Prince Edward Island': ['Charlottetown', 'Summerside', 'Stratford', 'Cornwall', 'Montague', 'Alberton', 'Georgetown'],
    'Quebec': ['Montreal', 'Quebec City', 'Laval', 'Gatineau', 'Longueuil', 'Sherbrooke', 'Saguenay', 'Lévis', 'Trois-Rivières'],
    'Saskatchewan': ['Saskatoon', 'Regina', 'Prince Albert', 'Moose Jaw', 'Swift Current', 'Yorkton', 'North Battleford'],
    'Yukon': ['Whitehorse', 'Dawson City', 'Watson Lake', 'Haines Junction', 'Carmacks']
  },
  'UK': {
    'England': ['London', 'Birmingham', 'Manchester', 'Liverpool', 'Leeds', 'Sheffield', 'Bristol', 'Leicester', 'Coventry', 'Nottingham', 'Newcastle', 'Southampton', 'Portsmouth', 'Brighton', 'Reading', 'Plymouth'],
    'Scotland': ['Edinburgh', 'Glasgow', 'Aberdeen', 'Dundee', 'Inverness', 'Perth', 'Stirling', 'Ayr', 'Paisley', 'Dunfermline'],
    'Wales': ['Cardiff', 'Swansea', 'Newport', 'Wrexham', 'Barry', 'Rhondda', 'Caerphilly', 'Bridgend', 'Llanelli'],
    'Northern Ireland': ['Belfast', 'Derry', 'Lisburn', 'Newry', 'Bangor', 'Ballymena', 'Newtownabbey', 'Craigavon']
  },
  'Australia': {
    'Australian Capital Territory': ['Canberra', 'Belconnen', 'Woden', 'Tuggeranong', 'Gungahlin', 'Weston Creek', 'Fyshwick'],
    'New South Wales': ['Sydney', 'Newcastle', 'Wollongong', 'Wagga Wagga', 'Coffs Harbour', 'Albury', 'Tamworth', 'Orange', 'Dubbo', 'Nowra'],
    'Northern Territory': ['Darwin', 'Alice Springs', 'Palmerston', 'Katherine', 'Tennant Creek', 'Nhulunbuy', 'Yulara'],
    'Queensland': ['Brisbane', 'Gold Coast', 'Townsville', 'Cairns', 'Toowoomba', 'Rockhampton', 'Mackay', 'Bundaberg', 'Hervey Bay'],
    'South Australia': ['Adelaide', 'Mount Gambier', 'Whyalla', 'Murray Bridge', 'Port Augusta', 'Port Pirie', 'Gawler', 'Mount Barker'],
    'Tasmania': ['Hobart', 'Launceston', 'Devonport', 'Burnie', 'Ulverstone', 'George Town', 'Kingston', 'Sorell'],
    'Victoria': ['Melbourne', 'Geelong', 'Ballarat', 'Bendigo', 'Shepparton', 'Warrnambool', 'Traralgon', 'Mildura', 'Sunbury'],
    'Western Australia': ['Perth', 'Fremantle', 'Rockingham', 'Mandurah', 'Albany', 'Bunbury', 'Geraldton', 'Kalgoorlie', 'Broome']
  },
  'New Zealand': {
    'Auckland': ['Auckland', 'North Shore', 'Manukau', 'Waitakere', 'Hamilton', 'Tauranga'],
    'Wellington': ['Wellington', 'Lower Hutt', 'Upper Hutt', 'Porirua', 'Palmerston North'],
    'Canterbury': ['Christchurch', 'Timaru', 'Ashburton', 'Rangiora', 'Kaiapoi'],
    'Waikato': ['Hamilton', 'Cambridge', 'Taupo', 'Te Awamutu', 'Tokoroa'],
    'Bay of Plenty': ['Tauranga', 'Rotorua', 'Whakatane', 'Taupo', 'Kawerau'],
    'Otago': ['Dunedin', 'Queenstown', 'Wanaka', 'Oamaru', 'Alexandra'],
    'Northland': ['Whangarei', 'Dargaville', 'Kaitaia', 'Kerikeri', 'Paihia'],
    'Hawke\'s Bay': ['Napier', 'Hastings', 'Havelock North', 'Wairoa', 'Waipukurau'],
    'Manawatu-Wanganui': ['Palmerston North', 'Whanganui', 'Levin', 'Feilding', 'Marton'],
    'Tasman': ['Nelson', 'Richmond', 'Motueka', 'Takaka', 'Mapua'],
    'Marlborough': ['Blenheim', 'Picton', 'Havelock', 'Seddon', 'Renwick'],
    'West Coast': ['Greymouth', 'Westport', 'Hokitika', 'Reefton', 'Franz Josef'],
    'Southland': ['Invercargill', 'Gore', 'Te Anau', 'Winton', 'Bluff']
  },
  'Singapore': {
    'Central Region': ['Singapore City', 'Orchard', 'Marina Bay', 'Sentosa', 'Bugis', 'Chinatown', 'Little India'],
    'East Region': ['Tampines', 'Bedok', 'Changi', 'Pasir Ris', 'Simei', 'Kembangan'],
    'West Region': ['Jurong East', 'Clementi', 'Bukit Batok', 'Tuas', 'Choa Chu Kang', 'Boon Lay'],
    'North Region': ['Woodlands', 'Yishun', 'Sembawang', 'Mandai', 'Admiralty'],
    'North-East Region': ['Hougang', 'Sengkang', 'Punggol', 'Serangoon', 'Kovan', 'Lorong Chuan']
  },
  'Japan': {
    'Hokkaido': ['Sapporo', 'Asahikawa', 'Hakodate', 'Kushiro', 'Obihiro', 'Otaru'],
    'Tokyo': ['Tokyo', 'Shibuya', 'Shinjuku', 'Shinagawa', 'Minato', 'Chiyoda', 'Meguro'],
    'Osaka': ['Osaka', 'Sakai', 'Higashiosaka', 'Hirakata', 'Suita', 'Toyonaka'],
    'Kanagawa': ['Yokohama', 'Kawasaki', 'Sagamihara', 'Fujisawa', 'Hiratsuka', 'Kamakura'],
    'Aichi': ['Nagoya', 'Toyota', 'Okazaki', 'Ichinomiya', 'Kasugai', 'Toyohashi'],
    'Fukuoka': ['Fukuoka', 'Kitakyushu', 'Kurume', 'Omuta', 'Iizuka'],
    'Kyoto': ['Kyoto', 'Uji', 'Maizuru', 'Kameoka', 'Nagaokakyo'],
    'Hyogo': ['Kobe', 'Himeji', 'Nishinomiya', 'Amagasaki', 'Akashi', 'Kakogawa'],
    'Saitama': ['Saitama', 'Kawagoe', 'Kawaguchi', 'Tokorozawa', 'Koshigaya', 'Urawa'],
    'Chiba': ['Chiba', 'Funabashi', 'Matsudo', 'Ichikawa', 'Kashiwa', 'Narashino'],
    'Hiroshima': ['Hiroshima', 'Fukuyama', 'Kure', 'Mihara', 'Onomichi'],
    'Okinawa': ['Naha', 'Okinawa City', 'Uruma', 'Ginowan', 'Ishigaki', 'Miyakojima']
  },
  'UAE': {
    'Abu Dhabi': ['Abu Dhabi', 'Al Ain', 'Madinat Zayed', 'Liwa', 'Ruwais', 'Ghayathi'],
    'Dubai': ['Dubai', 'Jebel Ali', 'Hatta', 'Al Barsha', 'Deira', 'Bur Dubai', 'Marina', 'Downtown'],
    'Sharjah': ['Sharjah', 'Khor Fakkan', 'Kalba', 'Dibba Al Hisn', 'Al Dhaid'],
    'Ajman': ['Ajman', 'Masfout', 'Manama'],
    'Ras Al Khaimah': ['Ras Al Khaimah', 'Digdaga', 'Khatt', 'Ghalilah'],
    'Umm Al Quwain': ['Umm Al Quwain', 'Falaj Al Moalla', 'Al Salamah'],
    'Fujairah': ['Fujairah', 'Dibba', 'Masafi', 'Qidfa', 'Al Bidya']
  },
  'Germany': {
    'Baden-Württemberg': ['Stuttgart', 'Karlsruhe', 'Mannheim', 'Freiburg', 'Heidelberg', 'Ulm'],
    'Bavaria': ['Munich', 'Nuremberg', 'Augsburg', 'Regensburg', 'Würzburg', 'Ingolstadt'],
    'Berlin': ['Berlin'],
    'Brandenburg': ['Potsdam', 'Cottbus', 'Brandenburg an der Havel', 'Frankfurt (Oder)'],
    'Bremen': ['Bremen', 'Bremerhaven'],
    'Hamburg': ['Hamburg'],
    'Hesse': ['Frankfurt', 'Wiesbaden', 'Kassel', 'Darmstadt', 'Offenbach'],
    'Lower Saxony': ['Hanover', 'Braunschweig', 'Osnabrück', 'Oldenburg', 'Wolfsburg'],
    'Mecklenburg-Vorpommern': ['Rostock', 'Schwerin', 'Stralsund', 'Greifswald'],
    'North Rhine-Westphalia': ['Cologne', 'Düsseldorf', 'Dortmund', 'Essen', 'Bonn', 'Münster', 'Bielefeld'],
    'Rhineland-Palatinate': ['Mainz', 'Ludwigshafen', 'Koblenz', 'Trier', 'Kaiserslautern'],
    'Saarland': ['Saarbrücken', 'Neunkirchen', 'Homburg'],
    'Saxony': ['Dresden', 'Leipzig', 'Chemnitz', 'Zwickau'],
    'Saxony-Anhalt': ['Magdeburg', 'Halle', 'Dessau-Roßlau'],
    'Schleswig-Holstein': ['Kiel', 'Lübeck', 'Flensburg', 'Neumünster'],
    'Thuringia': ['Erfurt', 'Jena', 'Gera', 'Weimar']
  },
  'Indonesia': {
    'Aceh': ['Banda Aceh', 'Lhokseumawe', 'Sabang'],
    'Bali': ['Denpasar', 'Ubud', 'Kuta', 'Seminyak', 'Sanur'],
    'Banten': ['Serang', 'Tangerang', 'South Tangerang', 'Cilegon'],
    'Central Java': ['Semarang', 'Surakarta', 'Magelang', 'Pekalongan', 'Tegal'],
    'East Java': ['Surabaya', 'Malang', 'Kediri', 'Madiun', 'Probolinggo'],
    'Jakarta': ['Central Jakarta', 'South Jakarta', 'East Jakarta', 'West Jakarta', 'North Jakarta'],
    'West Java': ['Bandung', 'Bekasi', 'Bogor', 'Depok', 'Cimahi'],
    'Yogyakarta': ['Yogyakarta', 'Sleman', 'Bantul'],
    'North Sumatra': ['Medan', 'Binjai', 'Pematangsiantar', 'Tebing Tinggi'],
    'South Sulawesi': ['Makassar', 'Parepare', 'Palopo'],
    'East Kalimantan': ['Samarinda', 'Balikpapan', 'Bontang', 'Tarakan'],
    'Riau': ['Pekanbaru', 'Dumai', 'Bengkalis'],
    'West Sumatra': ['Padang', 'Bukittinggi', 'Pariaman'],
    'Papua': ['Jayapura', 'Merauke', 'Biak'],
    'Lampung': ['Bandar Lampung', 'Metro', 'Pringsewu']
  },
  'Kuwait': {
    'Capital': ['Kuwait City', 'Sharq', 'Dasman', 'Mirqab'],
    'Hawalli': ['Hawalli', 'Salmiya', 'Jabriya', 'Bayan'],
    'Farwaniya': ['Farwaniya', 'Khaitan', 'Ardiya', 'Jleeb Al-Shuyoukh'],
    'Ahmadi': ['Ahmadi', 'Fahaheel', 'Mangaf', 'Fintas'],
    'Jahra': ['Jahra', 'Sulaibiya', 'Naeem'],
    'Mubarak Al-Kabeer': ['Sabah Al-Salem', 'Abu Halifa', 'Fnaitees']
  },
  'Netherlands': {
    'Drenthe': ['Assen', 'Emmen', 'Hoogeveen'],
    'Flevoland': ['Almere', 'Lelystad', 'Dronten'],
    'Friesland': ['Leeuwarden', 'Sneek', 'Heerenveen'],
    'Gelderland': ['Arnhem', 'Nijmegen', 'Apeldoorn', 'Ede'],
    'Groningen': ['Groningen', 'Delfzijl', 'Veendam'],
    'Limburg': ['Maastricht', 'Venlo', 'Heerlen', 'Roermond'],
    'North Brabant': ['Eindhoven', 'Tilburg', 'Breda', 'Den Bosch'],
    'North Holland': ['Amsterdam', 'Haarlem', 'Alkmaar', 'Zaandam'],
    'Overijssel': ['Zwolle', 'Enschede', 'Deventer', 'Almelo'],
    'South Holland': ['Rotterdam', 'The Hague', 'Leiden', 'Dordrecht', 'Delft'],
    'Utrecht': ['Utrecht', 'Amersfoort', 'Nieuwegein', 'Zeist'],
    'Zeeland': ['Middelburg', 'Vlissingen', 'Goes']
  },
  'Oman': {
    'Muscat': ['Muscat', 'Muttrah', 'Seeb', 'Bausher', 'Al Amerat'],
    'Dhofar': ['Salalah', 'Taqah', 'Mirbat'],
    'Musandam': ['Khasab', 'Bukha', 'Dibba'],
    'Al Buraimi': ['Al Buraimi', 'Mahdah'],
    'Ad Dakhiliyah': ['Nizwa', 'Bahla', 'Adam'],
    'Al Batinah North': ['Sohar', 'Shinas', 'Liwa'],
    'Al Batinah South': ['Rustaq', 'Barka', 'Nakhal'],
    'Ash Sharqiyah North': ['Ibra', 'Bidiya', 'Al Qabil'],
    'Ash Sharqiyah South': ['Sur', 'Jalan Bani Bu Ali', 'Masirah'],
    'Ad Dhahirah': ['Ibri', 'Yanqul', 'Dhank'],
    'Al Wusta': ['Haima', 'Duqm', 'Mahout']
  },
  'Saudi Arabia': {
    'Riyadh': ['Riyadh', 'Diriyah', 'Al Kharj', 'Al Majmaah'],
    'Makkah': ['Jeddah', 'Mecca', 'Taif', 'Rabigh'],
    'Madinah': ['Medina', 'Yanbu', 'Al Ula'],
    'Eastern Province': ['Dammam', 'Khobar', 'Dhahran', 'Jubail', 'Al Ahsa'],
    'Asir': ['Abha', 'Khamis Mushait', 'Bisha'],
    'Tabuk': ['Tabuk', 'Duba', 'Umluj'],
    'Hail': ['Hail', 'Baqaa', 'Al Ghazalah'],
    'Northern Borders': ['Arar', 'Rafha', 'Turaif'],
    'Jazan': ['Jazan', 'Sabya', 'Abu Arish'],
    'Najran': ['Najran', 'Sharurah'],
    'Al Bahah': ['Al Bahah', 'Baljurashi', 'Al Mandaq'],
    'Al Jawf': ['Sakaka', 'Qurayyat', 'Dumat Al Jandal'],
    'Qassim': ['Buraydah', 'Unaizah', 'Ar Rass']
  },
  'Sweden': {
    'Stockholm': ['Stockholm', 'Solna', 'Sundbyberg', 'Nacka', 'Huddinge'],
    'Västra Götaland': ['Gothenburg', 'Borås', 'Trollhättan', 'Uddevalla'],
    'Skåne': ['Malmö', 'Helsingborg', 'Lund', 'Kristianstad'],
    'Östergötland': ['Linköping', 'Norrköping', 'Motala'],
    'Uppsala': ['Uppsala', 'Enköping', 'Bålsta'],
    'Jönköping': ['Jönköping', 'Värnamo', 'Tranås'],
    'Halland': ['Halmstad', 'Varberg', 'Kungsbacka'],
    'Örebro': ['Örebro', 'Kumla', 'Karlskoga'],
    'Södermanland': ['Eskilstuna', 'Nyköping', 'Katrineholm'],
    'Dalarna': ['Falun', 'Borlänge', 'Ludvika'],
    'Gävleborg': ['Gävle', 'Sandviken', 'Hudiksvall'],
    'Värmland': ['Karlstad', 'Kristinehamn', 'Arvika'],
    'Norrbotten': ['Luleå', 'Kiruna', 'Boden', 'Piteå']
  }
};

// Get all countries
export const getCountries = () => Object.keys(locationData);

/** ISO / legacy codes from older forms → keys in locationData */
const ISO_TO_LOCATION_COUNTRY = {
  US: 'USA',
  CA: 'Canada',
  GB: 'UK',
  UK: 'UK',
  AU: 'Australia',
  IN: 'India',
  NZ: 'New Zealand',
  SG: 'Singapore',
  JP: 'Japan',
  AE: 'UAE',
  DE: 'Germany',
  ID: 'Indonesia',
  KW: 'Kuwait',
  NL: 'Netherlands',
  OM: 'Oman',
  SA: 'Saudi Arabia',
  SE: 'Sweden',
};

/**
 * Map stored country (ISO code, legacy value, or locationData key) to a value
 * that matches edit-form country dropdown options.
 */
export const normalizeCountryForForm = (country) => {
  if (country == null || country === '') return '';
  const c = String(country).trim();
  if (locationData[c]) return c;
  const fromIso = ISO_TO_LOCATION_COUNTRY[c] || ISO_TO_LOCATION_COUNTRY[c.toUpperCase()];
  if (fromIso && locationData[fromIso]) return fromIso;
  const matchKey = Object.keys(locationData).find(
    (key) => key.toLowerCase() === c.toLowerCase()
  );
  return matchKey || c;
};

/** Human-friendly country for view labels (does not change stored data). */
export const formatCountryForDisplay = (country) => normalizeCountryForForm(country) || country || '';

// Get states for a country
export const getStates = (country) => {
  if (!country || !locationData[country]) return [];
  return Object.keys(locationData[country]);
};

// Get cities for a state in a country
export const getCities = (country, state) => {
  if (!country || !state || !locationData[country] || !locationData[country][state]) return [];
  return locationData[country][state];
};










